export const ActionTypes = {
  FETCH_ALL: 'services/shift/fetch_all',
  FETCH_ALL_SUCCESS: 'services/shift/fetch_all_success',
  SET_LOADER_STATUS: 'services/shift/set_loader_status',
  SET_ALL: 'services/shift/set_all',
  ADD_OR_UPDATE_SHIFT: 'services/shift/add_or_update_shift',
  DELETE_SHIFT: 'services/shift/delete_shift',
  FETCH_SHIFTS_BY_FACTORY_ID: 'services/shift/fetch_shifts_by_factory_id',
  FETCH_SHIFTS_BY_JOB_EQUIPMENT_ID: 'services/shift/fetch_shifts_by_job_equipment_id',
  SET_SHIFTS_BY_FACTORY_ID: 'services/shift/set_shifts_by_factory_id',
  FETCH_FACTORY_SHIFT_BY_TIME_RANGE: 'services/shift/fetch_factory_shift_by_time_range',
  SET_FACTORY_SHIFT_BY_TIME_RANGE: 'services/shift/set_factory_shift_by_time_range',
  FETCH_EQUIPMENT_SHIFT: 'services/shift/fetch_equipment_shift',
  SET_EQUIPMENT_SHIFT: 'services/shift/set_equipment_shift',
  SET_EQUIPMENT_SHIFT_BY_ID: 'services/shift/set_equipment_shift_by_id',
  SET_EQUIPMENT_SHIFT_LOADER: 'services/shift/set_equipment_shift_loader',
  SET_IS_DISABLED: 'services/shift/set_is_disabled',
  FETCH_JOB_EQUIPMENT_SHIFTS_BY_JOB_ID: 'services/shift/fetch_job_equipment_shifts_by_job_id',
  SET_JOB_EQUIPMENT_SHIFTS_BY_JOB_ID: 'services/shift/set_job_equipment_shifts_by_job_id',
  FETCH_LINE_JOB_EQUIPMENT_SHIFTS_BY_LINE_JOB_ID: 'services/shift/fetch_line_job_equipment_shifts_by_line_job_id',
  SET_LINE_JOB_EQUIPMENT_SHIFTS_BY_LINE_JOB_ID: 'services/shift/set_line_job_equipment_shifts_by_line_job_id',
  FETCH_FACTORY_CURRENT_SHIFT_BY_FACTORY_ID: 'services/shift/fetch_factory_current_shift_by_factory_id',
  SET_FACTORY_CURRENT_SHIFT_BY_FACTORY_ID: 'services/shift/set_factory_current_shift_by_factory_id',
};

const fetchAll = ({ shiftParams }) => ({
  shiftParams,
  type: ActionTypes.FETCH_ALL,
});

const setIsDisabled = ({ rowId, isDisabled }) => ({
  rowId,
  isDisabled,
  type: ActionTypes.SET_IS_DISABLED,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const setAll = ({ allShift }) => ({
  allShift,
  type: ActionTypes.SET_ALL,
});

const addorUpdateShift = ({ shiftData, actionName, shiftParams }) => ({
  shiftData,
  actionName,
  shiftParams,
  type: ActionTypes.ADD_OR_UPDATE_SHIFT,
});

const deleteShift = ({ id, shiftParams }) => ({
  id,
  shiftParams,
  type: ActionTypes.DELETE_SHIFT,
});

const fetchShiftsByFactoryId = ({ factoryId }) => ({
  factoryId,
  type: ActionTypes.FETCH_SHIFTS_BY_FACTORY_ID,
});

const fetchShiftsByJobEquipmentId = ({ jobEquipmentId }) => ({
  jobEquipmentId,
  type: ActionTypes.FETCH_SHIFTS_BY_JOB_EQUIPMENT_ID,
});

const setShiftsByFactoryId = ({ factoryShifts }) => ({
  factoryShifts,
  type: ActionTypes.SET_SHIFTS_BY_FACTORY_ID,
});

const fetchFactoryShiftByTimeRange = ({ shiftParams }) => ({
  shiftParams,
  type: ActionTypes.FETCH_FACTORY_SHIFT_BY_TIME_RANGE,
});

const setFactoryShiftByTimeRange = ({ factoryShift }) => ({
  factoryShift,
  type: ActionTypes.SET_FACTORY_SHIFT_BY_TIME_RANGE,
});

const fetchEquipmentShift = ({ equipmentShiftParams }) => ({
  equipmentShiftParams,
  type: ActionTypes.FETCH_EQUIPMENT_SHIFT,
});

const setEquipmentShift = ({ equipmentShift }) => ({
  equipmentShift,
  type: ActionTypes.SET_EQUIPMENT_SHIFT,
});

const setEquipmentShiftById = ({ equipmentShiftById }) => ({
  equipmentShiftById,
  type: ActionTypes.SET_EQUIPMENT_SHIFT_BY_ID,
});
const setLoaderEquipmentShift = ({ showEquipmentShiftLoader }) => ({
  showEquipmentShiftLoader,
  type: ActionTypes.SET_EQUIPMENT_SHIFT_LOADER,
});
const fetchJobEquipmentShiftsByJobId = ({ jobId, callback }) => ({
  jobId,
  callback,
  type: ActionTypes.FETCH_JOB_EQUIPMENT_SHIFTS_BY_JOB_ID,
});
const setJobEquipmentShiftsByJobId = ({ jobEquipmentShiftsData }) => ({
  jobEquipmentShiftsData,
  type: ActionTypes.SET_JOB_EQUIPMENT_SHIFTS_BY_JOB_ID,
});
const fetchLineJobEquipmentShiftsByLineJobId = ({ lineJobId, callback }) => ({
  lineJobId,
  callback,
  type: ActionTypes.FETCH_LINE_JOB_EQUIPMENT_SHIFTS_BY_LINE_JOB_ID,
});
const setLineJobEquipmentShiftsByLineJobId = ({ lineJobEquipmentShiftsData }) => ({
  lineJobEquipmentShiftsData,
  type: ActionTypes.SET_LINE_JOB_EQUIPMENT_SHIFTS_BY_LINE_JOB_ID,
});

const fetchFactoryCurrentShiftByFactoryId = ({ factoryId }) => ({
  factoryId,
  type: ActionTypes.FETCH_FACTORY_CURRENT_SHIFT_BY_FACTORY_ID,
});

const setFactoryCurrentShiftByFactoryId = ({ factoryCurrentShift }) => ({
  factoryCurrentShift,
  type: ActionTypes.SET_FACTORY_CURRENT_SHIFT_BY_FACTORY_ID,
});

export default {
  fetchAll,
  setIsDisabled,
  setAll,
  setLoader,
  addorUpdateShift,
  deleteShift,
  fetchShiftsByFactoryId,
  fetchShiftsByJobEquipmentId,
  setEquipmentShiftById,
  setShiftsByFactoryId,
  fetchFactoryShiftByTimeRange,
  setFactoryShiftByTimeRange,
  fetchEquipmentShift,
  setEquipmentShift,
  setLoaderEquipmentShift,
  fetchJobEquipmentShiftsByJobId,
  setJobEquipmentShiftsByJobId,
  fetchLineJobEquipmentShiftsByLineJobId,
  setLineJobEquipmentShiftsByLineJobId,
  fetchFactoryCurrentShiftByFactoryId,
  setFactoryCurrentShiftByFactoryId,
};
